import Tooltip from '@material-ui/core/Tooltip';
import { Theme, withStyles } from '@material-ui/core/styles';

export const LightTooltip = withStyles((theme: Theme) => ({
  tooltip: {
    position: 'relative',
    backgroundColor: 'rgba(163, 163, 245, 1)',
    border: '1px solid rgba(105, 105, 237, 1)',
    color: theme.palette.common.white,
    boxShadow: theme.shadows[1],
    display: 'flex',
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 14,
    fontWeight: 'bold',
    fontFamily: '"sofia-pro", sans-serif',
    '&:before': {
      content: '""',
      display: 'block',
      width: 0,
      height: 0,
      position: 'absolute',
      borderRight: '5px solid transparent',
      borderLeft: '5px solid transparent',
      borderTop: '5px solid rgba(163, 163, 245, 1)',
      bottom: -5,
      left: '50%',
      transform: 'translateX(-50%)',
    },
  },
  popper: {},
}))(Tooltip);
